import { Box, Tab, useMediaQuery } from '@mui/material';
import { AbilityContext } from '../context/Ability';
import { useContext } from 'react';
import { TabContext, TabList } from '@mui/lab';
import { subject } from '@casl/ability';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser } from '../features/Auth/authSlice';
import { setPreview } from '../features/Gift/giftSlice';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Overlay from '../features/WebView/components/Overlay';

function Gift() {
  const ability = useContext(AbilityContext);
  const user = useSelector(selectCurrentUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const value = pathname.split('/gift/')[1];
  const comingSoon = true
  const handleChange = (event, newValue) => {
    navigate(newValue);
    switch (newValue) {
      case 'mygift':
        dispatch(setPreview({ my: true }));
        break;
      case 'submitted':
        dispatch(setPreview({ reset: true }));
      case 'invites':
        dispatch(setPreview({ reset: true }));
    }
  };
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <Box
      sx={{
        position: 'relative',
        height: 'calc(100vh - 90px)',
        width: '100%',
        borderRadius: '8px',
        border: '1px solid #E6E6E6',
        p: 5,
      }}
    >
      {comingSoon ? (
        <Box sx={{ backgroundColor: 'white', m: 5 }}>
          <Overlay />
        </Box>
      ) : ability.can('manage', 'GiftForm') ? (
        <Outlet />
      ) : ( 
        <TabContext value={value}>
          <Box sx={{ border: 0 }}>
            <TabList
              onChange={handleChange}
              variant={isMobile ? 'scrollable' : 'standard'}
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                '& .MuiTabScrollButton-root': {
                  display: 'none',
                },
              }}
            >
              {/* Only visible if the user has permission to read forms submitted by him */}
              {ability.can('read', 'GiftForm') && <Tab label="My GIFT" value="mygift" />}

              {/* Only visible if the user has permission to read forms submitted to him */}
              {ability.can('read', subject('GiftForm', { deliveryHead: user?.empCode })) && (
                <Tab label="Submitted GIFT" value="submitted" />
              )}

              {/* Only visible if the user has permission to get invites*/}
              {ability.can('read', 'Interview') && <Tab label="Interview invites" value="invites" />}
            </TabList>
          </Box>

          {/* for display routes */}
          <Box sx={{ backgroundColor: 'white' }}>
            <Outlet />
          </Box>

          {/* for display coming soon  */}
        </TabContext>
      )}
    </Box>
  );
}

export default Gift;
